import styled from 'styled-components'

const StepHeadlineUi = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
`

export default StepHeadlineUi
